export class LanguageService {

    static text(key){
      return key;
    }

    constructor(){
      this.language = localStorage.getItem("language") || "pt-BR";
    }

    setLanguage(lang){
      localStorage.setItem("language", lang);
      this.language = lang;
    }

    getLanguage(){
      return this.language || "pt-BR";
    }

    getText(key){
      if(this.data[this.language][key]){
        return this.data[this.language][key];
      }
      else {
        //console.log(`"${key}": "${key}"`);
        return key;
      }
      
    }

    data = {
      "pt-BR": {
        "Portuguese": "Português",
        "English": "Inglês",
        "Select_Language": "Selecione o idioma",
        "Dashboard": "Dashboard",
        "People": "Pessoas",
        "Reports": "Relatórios",
        "Tags": "Tags",
        "Management": "Gestão",
        "Favorites": "Favoritos",
        "My Favorites": "Meus Favoritos",
        "Show_All": "Ver Todos",
        "Show_Only_Favorites": "Ver Apenas Favoritos",
        "No_Favorites_Message": "Você ainda não tem nenhum favorito. Clique em 'Ver Todos' para visualizar todos os relatórios disponíveis.",
        "Saved_Filters": "Filtros Salvos",
        "Name": "Nome",
        "Manage_People": "Gereciar Pessoas",
        "Search": "Buscar",
        "Cancel": "Cancelar",
        "Save": "Salvar",
        "Permission_Denied": "Permissão Negada",
        "Person_Details": "Detalhes da Pessoa",
        "E-mail": "E-mail",
        "Profile": "Perfil",
        "Active": "Ativo",
        "Are_you_sure_you_want_to_delete": "Tem certeza que deseja deletar",
        "Available": "Disponíveis",
        "Selected": "Selecionados",
        "Yes": "Sim",
        "No": "Não",
        "New": "Novo",
        "Successful": "Sucesso",
        "Person_Updated": "Pessoa Atualizada",
        "is_required": "é obrigatório(a)",
        "Person_Created": "Pessoa Criada",
        "Person_Deleted": "Pessoa Deletada",
        "Clients": "Clientes",
        "Profiles": "Perfis",
        "Users": "Usuários",
        "Client": "Cliente",
        "Language": "Idioma",
        "Logout": "Sair",
        "Update_Password": "Alterar Senha",
        "Manage": "Gerenciar",
        "Item_Updated": "Item Atualizado",
        "Item_Created": "Item Criado",
        "Item_Deleted": "Item Deletado",
        "Item_Details": "Detalhes",
        "Confirm": "Confirmar",
        "Different_Passowrds": "Senhas diferentes",
        "Incorrect_Current_Password": "Senha atual errada",
        "Current_Password": "Senha atual",
        "New_Password": "Nova senha",
        "Confirm_Password": "Confirme sua nova senha",
        "Update_Password": "Alterar Senha",
        "Default_for_New_User": "Padrão para novos usuários",
        "Configurations": "Configurações",
        "Self Sign-Up": "Auto Inscrição",
        "ConfigurationsSaved": "Configurações Atualizadas",
        "Manage_Clients": "Gerenciar Clientes",
        "Client_Updated": "Cliente Atualizado",
        "Identity": "Identificação",
        "Manage_Customers": "Gerenciar Clientes",
        "Type": "Tipo",
        "Registration_Number": "CPF / CNPJ",
        "Customer_Details": "Detalhes do Cliente",
        "Company": "Pessoa Jurídica",
        "Individual": "Pessoa Física",
        "Address": "Endereço",
        "Street": "Logradouro",
        "Number": "Número",
        "Complement": "Complemento",
        "City": "Cidade",
        "State": "Estado",
        "ZipCode": "CEP",
        "Manage_Subscriptions": "Gerenciar Assinaturas",
        "Customer": "Cliente",
        "SubscriptionPlan": "Plano de Assinatura",
        "Status": "Status",
        "Start": "Início",
        "End": "Término",
        "Subscription": "Assinatura",
        "RegistrationNumber": "CPF/CNPJ",
        "Expiration": "Prazo",
        "Price": "Valor",
        "Manage_SubscriptionsPlans": "Gerenciar Planos de Assinaturas",
        "BasicInfo": "Informações Básicas",
        "Description": "Descrição",
        "months": "meses"
      },
      "en-US": {
        "Portuguese": "Portuguese",
        "English": "English",
        "Select_Language": "Select Language",
        "Dashboard": "Dashboard",
        "People": "People",
        "Reports": "Reports",
        "Tags": "Tags",
        "Management": "Management",
        "Favorites": "Favorites",
        "My Favorites": "My Favorites",
        "Show_All": "Show All",
        "Show_Only_Favorites": "Show Only Favorites",
        "No_Favorites_Message": "You don't have anny favorites yet. Click on 'Show All' to see the complete report list.",
        "Saved_Filters": "Saved Filters",
        "Name": "Name",
        "Manage_People": "Manage People",
        "Search": "Search",
        "Cancel": "Cancel",
        "Save": "Save",
        "Permission_Denied": "Permission Denied",
        "Person_Details": "Person_Details",
        "E-mail": "E-mail",
        "Profile": "Profile",
        "Active": "Active",
        "Are_you_sure_you_want_to_delete": "Are you sure you want to delete",
        "Available": "Available",
        "Selected": "Selected",
        "Yes": "Yes",
        "No": "No",
        "New": "New",
        "Successful": "Successful",
        "Person_Updated": "Person Updated",
        "is_required": "is required",
        "Person_Created": "Person Created",
        "Person_Deleted": "Person Deleted",
        "Clients": "Clients",
        "Profiles": "Profiles",
        "Users": "Users",
        "Client": "Client",
        "Language": "Language",
        "Logout": "Logout",
        "Update_Password": "Update Password",
        "Manage": "Manage",
        "Item_Updated": "Item Updated",
        "Item_Created": "Item Created",
        "Item_Deleted": "Item Deleted",
        "Item_Details": "Item Details",
        "Confirm": "Confirm",
        "Different_Passowrds": "Passwords don't match",
        "Incorrect_Current_Password": "Incorrect Current Password",
        "Current_Password": "Current Password",
        "New_Password": "New Password",
        "Confirm_Password": "Please confirm new password",
        "Update_Password": "Update Password",
        "Default_for_New_User": "Default for New Users",
        "Configurations": "Configurations",
        "Self Sign-Up": "Self Sign-Up",
        "ConfigurationsSaved": "Configurations Saved",
        "Manage_Clients": "Manage Clients",
        "Client_Updated": "Client Updated",
        "Identity": "Identity",
        "Manage_Customers": "Manage Customers",
        "Type": "Type",
        "Registration_Number": "Registration Number",
        "Customer_Details": "Customer Details",
        "Company": "Company",
        "Individual": "Individual",
        "Address": "Address",
        "Street": "Street",
        "Number": "Number",
        "Complement": "Complement",
        "City": "City",
        "State": "State",
        "ZipCode": "ZipCode",
        "Manage_Subscriptions": "Manage Subscriptions",
        "Customer": "Customer",
        "SubscriptionPlan": "Subscription Plan",
        "Status": "Status",
        "Start": "Start",
        "End": "End",
        "Subscription": "Subscription",
        "RegistrationNumber": "Registration Number",
        "Expiration": "Expiration Period",
        "Price": "Price",
        "Manage_SubscriptionsPlans": "Manage Subscription Plans",
        "BasicInfo": "Basic Info",
        "Description": "Description",
        "months": "months"
      }
    }
}